import React from "react";
import Badge from "ui/Badge/Badge";
import { TooltipProps } from "ui/Tooltip/Tooltip";
import { BadgeProps } from "ui/Badge/Badge";
import BadgeWithTooltip from "common/BadgeWithTooltip/BadgeWithTooltip";
import AdvertisementBadge from "common/AdvertisementBadge/AdvertisementBadge";
import styles from "./Badges.module.scss";

type Props = {
  badges: Array<Entity.ProductBadge>;
  alt?: string;
  tooltipProps?: Pick<TooltipProps, "placement" | "width" | "maxWidth">;
  advertisementTooltipProps?: Pick<TooltipProps, "width" | "maxWidth">;
  badgeProps?: BadgeProps;
};

const Badges: React.FC<Props> = ({
  badges,
  tooltipProps,
  alt,
  badgeProps,
  advertisementTooltipProps,
}: Props) => {
  return (
    <div className={styles.badges}>
      {badges.map((badge, index) => {
        if (badge.type === "adv")
          return (
            <AdvertisementBadge
              key={index}
              {...badgeProps}
              tooltipProps={advertisementTooltipProps}
              type="product"
              advertiser={badge.description}
            />
          );

        return badge.description ? (
          <BadgeWithTooltip
            key={index}
            badge={badge}
            tooltipProps={tooltipProps}
            alt={alt}
            badgeProps={{
              ...badgeProps,
              withImage: !!badge.src,
              color: badge.color,
            }}
          />
        ) : (
          <Badge
            key={index}
            {...badgeProps}
            type={badge.type}
            withImage={!!badge.src}
            color={badge.color}
          >
            {badge.src ? (
              <img key={index} src={badge.src} alt={alt} />
            ) : (
              badge.title
            )}
          </Badge>
        );
      })}
    </div>
  );
};

export default Badges;
